/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function SignatureIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="78.5"
        cy="78.5"
        r="77.5"
        fill={mainColor}
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M104.228 80.4275L65.9513 118.704C64.3024 120.353 62.0661 121.279 59.7343 121.279H41.3959C38.9681 121.279 36.9999 119.311 36.9999 116.883V98.5444C36.9999 96.2128 37.9262 93.9765 39.575 92.3276L77.8518 54.051L104.228 80.4275Z"
        fill={secondaryColor}
      />
      <path
        d="M110.445 74.21L84.0689 47.8339L92.3277 39.575C95.761 36.1415 101.328 36.1415 104.761 39.575L118.704 53.5174C122.137 56.9509 122.137 62.5177 118.704 65.9513L110.445 74.21Z"
        fill={secondaryColor}
      />
    </svg>
  );
}
SignatureIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
SignatureIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(SignatureIcon);
memoized.displayName = 'SignatureIcon';
export default memoized;
